import { convertDropdownValueToKey } from 'utils/idUtils';
import { cloneDeep } from 'lodash';
import { FIELD_TYPES } from '../../utils/constants';

function fromGQL(obj) {
  const clonedObj = cloneDeep(obj);
  const { value, ...returnableField } = clonedObj;

  if (value && value.options && (value.defaultOption || value.defaultOption === '')) {
    const conformedOptions = {};
    const optionsOrder = [];

    value.options.forEach((option) => {
      const optionId = convertDropdownValueToKey(option.value);

      conformedOptions[optionId] = {
        value: option.value,
        label: option.label,
        shouldDisplay: true,
      };

      optionsOrder.push(optionId);
    });

    if (value.adminType && value.adminType === FIELD_TYPES.DROPDOWN) {
      delete value.stacked;
      delete value.adminType;
      return {
        ...returnableField,
        editors: {
          dropdownConfig: { ...value, options: conformedOptions, optionsOrder },
          editorType: FIELD_TYPES.RADIO_BUTTON,
        },
      };
    }

    return {
      ...returnableField,
      editors: {
        dropdownConfig: { ...value, options: conformedOptions, optionsOrder },
        editorType: FIELD_TYPES.DROPDOWN,
      },
    };
  }

  return {
    ...returnableField,
    editors: {
      dropdownConfig: { options: {}, defaultOption: '', optionsOrder: [] },
      editorType: FIELD_TYPES.DROPDOWN,
    },
  };
}

function toGQL({ editors }) {
  const { options, optionsOrder } = editors.dropdownConfig;
  const conformedOptions = optionsOrder.reduce((acc, curr) => {
    if (options[curr].shouldDisplay) {
      acc.push({
        value: options[curr].value,
        label: options[curr].label,
      });
    }
    return acc;
  }, []);

  const conformedConfig = {
    ...editors.dropdownConfig,
    options: conformedOptions,
  };
  delete conformedConfig.optionsOrder;

  if (editors.editorType === FIELD_TYPES.RADIO_BUTTON) {
    conformedConfig.stacked = true;
    conformedConfig.adminType = FIELD_TYPES.DROPDOWN;
    return {
      value: conformedConfig,
      type: FIELD_TYPES.RADIO_BUTTON,
    };
  }
  return { value: conformedConfig };
}

export default {
  fromGQL,
  toGQL,
};
